import React, { useEffect, useState } from "react";
import { Tr, Td, Image, Button, Text, Flex } from "@chakra-ui/react";
import { BsFillTrash3Fill } from "react-icons/bs";




export const CartItem = ({ srNo, id, image, title, price, handleDelete,setTotalPrice ,totalPrice}) => {
    const [quantity,setQuantity]=useState(1)

    useEffect(() => {

    }, [])

    const handleChange=()=>{
      
        setQuantity(quantity)
        totalPrice+=price
        setTotalPrice(totalPrice)

    }




    return (
        <>

            <Tr>
                <Td>{srNo}</Td>
                <Td><Image src={image} /></Td>
                <Td >{title}</Td>
                <Td >{price}</Td>
                <Td>
                    <Flex>
                        <Td> <Button onClick={handleChange}>+</Button></Td>
                        <Td><Text>{quantity}</Text></Td>
                        <Td><Button>-</Button></Td>
                        <Td><Button onClick={() => handleDelete(id)}><BsFillTrash3Fill/></Button></Td>
                    </Flex>

                </Td>

                <Td><Button >Delete</Button></Td>
            </Tr>

        </>
    )

}